<script>
	import { getContext } from 'svelte'
	import { key } from './Table.svelte'

	export let border_r = null
	export let colspan = null
	export let cls = null

	let tableContext = null
	tableContext = getContext(key)
</script>

<td
	{colspan}
	class="
  {tableContext?.td_padding ? tableContext.td_padding : 'p-4'} 
  {tableContext?.td_border ? tableContext.td_border : 'border-neutral-300'} 
  {tableContext?.tdcls ?? ''}
  {cls ?? ''}
  "
	class:border-r={border_r}
>
	<slot />
</td>
